module.exports = __webpack_public_path__ + "static/media/gw.f0742332.svg";